import { useMemo, useState } from 'react'
import { Box, Button, FormControl, FormHelperText, MenuItem, Typography } from '@mui/material'
import Select, { SelectChangeEvent } from '@mui/material/Select'
import { useAppSelector, useAppDispatch } from 'store/hooks'
import { selectCheckresponse } from 'slices/checkresponseSlice'
import { finishdelivery } from 'slices/finishdeliverySlice'
import { selectStartdelivery } from 'slices/startdeliverySlice'
import { QRCode } from 'components/QRCode/QRCode'

const responseOptions = ['お届けが完了しました', '持ち帰ります']

export const CustomerResponse = () => {
  const { response, status } = useAppSelector(selectCheckresponse)
  const customerMessage = useMemo(() => {
    if (status === 'success' && response?.message) {
      return response.message
    }
    return ''
  }, [response?.message, status])
  const unlockCode = useMemo(() => {
    if (status === 'success' && response?.unlockCode) {
      return response.unlockCode
    }
    return ''
  }, [response?.unlockCode, status])

  const [showResponse, setShowResponse] = useState(true)
  const handleNextClick = () => {
    setShowResponse(!showResponse)
  }

  const [message, setMessage] = useState('')
  const handleChange = (event: SelectChangeEvent) => {
    setMessage(event.target.value as string)
  }

  const dispatch = useAppDispatch()
  const { sessionId } = useAppSelector(selectStartdelivery)

  const disabled = useMemo(() => !message, [message])

  const handleClick = () => {
    dispatch(finishdelivery({ sessionId, message }))
  }

  return showResponse ? (
    <>
      <Box sx={{ backgroundColor: 'grey.200', p: 2 }}>
        <Typography textAlign="center" sx={{ mb: 1 }}>
          置き配の指示を受けました
        </Typography>
      </Box>
      <Box sx={{ p: 2 }}>
        {unlockCode && (
          <Box sx={{ my: 4, display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
            <Typography sx={{ fontWeight: 'bold', color: 'grey.700', mb: 4 }}>以下QRコードを</Typography>
            <Typography sx={{ fontWeight: 'bold', color: 'grey.700' }}>CONNECT1にかざしてください</Typography>
            {<QRCode text={unlockCode} />}
          </Box>
        )}

        <Box sx={{ backgroundColor: 'grey.200', p: 2 }}>
          <Typography sx={{ mb: 1, fontWeight: 'bold' }}>居住者からのメッセージ</Typography>
          <Box sx={{ typography: 'body2', whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{customerMessage}</Box>
        </Box>

        <Button variant="outlined" fullWidth sx={{ my: 3 }} onClick={handleNextClick}>
          配達完了連絡ページへ
        </Button>
      </Box>
    </>
  ) : (
    <Box sx={{ p: 2 }}>
      <FormControl fullWidth>
        <Box sx={{ display: 'flex', alignItems: 'center', my: 1 }}>
          <Typography sx={{ fontWeight: 'bold' }}>メッセージ選択</Typography>
        </Box>

        <Select displayEmpty value={message} onChange={handleChange}>
          <MenuItem sx={{ display: 'none', color: 'grey.500' }} value="">
            選択してください
          </MenuItem>
          {responseOptions.map(option => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </Select>
        <FormHelperText>居住者へ伝えたいメッセージを選択してください</FormHelperText>
      </FormControl>

      <Button variant="contained" disabled={disabled} fullWidth sx={{ my: 3 }} onClick={handleClick}>
        この内容で居住者に連絡する
      </Button>
      <Button variant="outlined" fullWidth onClick={handleNextClick}>
        戻る
      </Button>
    </Box>
  )
}
